import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { trackPageView } from "@/lib/ga4";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import HomePage from "@/pages/HomePage";
import SolutionsPage from "@/pages/SolutionsPage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CalculatorPage from "@/pages/CalculatorPage";
import QuotePage from "@/pages/QuotePage";
import QuoteResultsPage from "@/pages/QuoteResultsPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import CaseStudiesPage from "@/pages/CaseStudiesPage";
import CaseStudyUruPage from "@/pages/CaseStudyUruPage";
import CaseStudyBetulPage from "@/pages/CaseStudyBetulPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import DGReplacementPage from "@/pages/solutions/DGReplacementPage";
import SolarStoragePage from "@/pages/solutions/SolarStoragePage";
import RestaurantsPage from "@/pages/solutions/RestaurantsPage";
import HospitalsPage from "@/pages/solutions/HospitalsPage";
import CampusesPage from "@/pages/solutions/CampusesPage";
import WarehousesPage from "@/pages/solutions/WarehousesPage";
import ApartmentsPage from "@/pages/solutions/ApartmentsPage";
import EVChargingPage from "@/pages/solutions/EVChargingPage";
import ComparePage from "@/pages/ComparePage";
import { CartProvider } from "@/lib/cartContext";
import { CompareProvider } from "@/lib/compareContext";
import { Toaster } from "@/components/ui/sonner";
import { DebugFooter } from "@/components/DebugFooter";

function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(pathname + search);
  }, [pathname, search]);
  return null;
}

function AppLayout() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/solutions/dg-replacement" element={<DGReplacementPage />} />
          <Route path="/solutions/solar-storage" element={<SolarStoragePage />} />
          <Route path="/solutions/restaurants" element={<RestaurantsPage />} />
          <Route path="/solutions/hospitals" element={<HospitalsPage />} />
          <Route path="/solutions/campuses" element={<CampusesPage />} />
          <Route path="/solutions/warehouses" element={<WarehousesPage />} />
          <Route path="/solutions/apartments" element={<ApartmentsPage />} />
          <Route path="/solutions/ev-charging" element={<EVChargingPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:sku" element={<ProductDetailPage />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/calculator" element={<CalculatorPage />} />
          <Route path="/quote" element={<QuotePage />} />
          <Route path="/quote/results/:quoteId" element={<QuoteResultsPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/case-studies/uru" element={<CaseStudyUruPage />} />
          <Route path="/case-studies/tfl-betul" element={<CaseStudyBetulPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          {/* Legacy URL mappings */}
          <Route path="/#page-1" element={<Navigate to="/solutions" replace />} />
          <Route path="/#page-2" element={<Navigate to="/calculator" replace />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="top-right" />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <CartProvider>
          <CompareProvider>
            <AppLayout />
          </CompareProvider>
        </CartProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
